export default (value, questionModel) => {
  const fullData = value.replace('- ', '');
  const [timeStart, timeEnd] = fullData.split(" ");

  if (timeStart && timeEnd) {
    let [hourStartString, minutesStartString] = timeStart.split(':');
    let [hourEndString, minutesEndString] = timeEnd.split(':');
    
    const hourStart = Number(hourStartString), minutesStart = Number(minutesStartString);
    const hourEnd = Number(hourEndString), minutesEnd = Number(minutesEndString);

    if (hourStart > hourEnd || ((hourStart === hourEnd) && minutesStart >= minutesEnd )) {
      questionModel.description = '❌ O primeiro horário do intervalo deve ser menor que o segundo';
      return false;
    }

    if (hourStart > 24 || hourStart < 0) {
      questionModel.description = '❌ As HORAS do horário de início estão INVÁLIDAS';
      return false;
    }
 
    if (minutesStart >= 60 || minutesStart < 0) {
      questionModel.description = '❌ Os MINUTOS do horário de início estão INVÁLIDOS';
      return false;
    }

    if (hourEnd > 24 || hourEnd < 0) {
      questionModel.description = '❌ As HORAS do horário de término estão INVÁLIDAS';
      return false;
    }

    if (minutesEnd >= 60 || minutesEnd < 0) {
      questionModel.description = '❌ Os minutos do horário de término estão INVÁLIDOS';
      return false;
    }

    questionModel.description = '';
    return true;
  }

  return false;
};
